import Swiper, { Pagination, Navigation, Autoplay, Thumbs } from 'swiper';
import './scss/index.scss';

Swiper.use([ Pagination, Navigation, Autoplay, Thumbs ]);

export { Swiper };